import { ReactNode } from "react"

import { Container, cn } from "@podcastsoundboard/ps-lib/ui"

interface FullPageContentContainerProps {
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false
  children: ReactNode
  minHeight?: string
  className?: string
}

const FullPageContentContainer: React.FC<FullPageContentContainerProps> = ({
  maxWidth = "md",
  children,
  minHeight = "70vh",
  className,
}) => {
  return (
    <Container
      maxWidth={maxWidth}
      className={cn("items-stretch py-8", className)}
      style={{ minHeight }}
    >
      {children}
    </Container>
  )
}
export default FullPageContentContainer
